<template>
    <div
        id="milestone-ribbon"
        class="d-flex align-items-stretch justify-content-center px-3"
        style="flex-wrap: wrap">
        <milestone
            v-for="(milestone, index) in milestones"
            v-bind:key="'milestone' + index"
            ref="milestonesComponents"
            v-bind:content="milestone.Title ? milestone.Title : placeholder"
            v-bind:override-height="overrideHeight"
            v-bind:is-present="milestone.IsCurrent" />
    </div>
</template>
<script>
    import milestone from "./milestone.vue";
    export default {
        components: {
            milestone
        },
        props: {
            milestones: { type: Array, required: true },
            placeholder: { type: String, required: false, default: "" }
        },
        data() {
            return {
                overrideHeight: null
            };
        },
        async mounted() {
            await this.$nextTick();
            let maxHeight = 0;
            for (const milestone of this.$refs.milestonesComponents) {
                const milestoneBB = milestone.$el.getBoundingClientRect();
                if (milestoneBB.height > maxHeight) {
                    maxHeight = milestoneBB.height;
                }
            }
            this.overrideHeight = maxHeight;
        }
    };
</script>
